import toast from "react-hot-toast";
import { getErpRequestErrorMessage } from "../erpClient";

function messageFromResponseData(data) {
  if (!data || typeof data !== "object") return "";
  const m =
    (typeof data.message === "string" && data.message.trim()) ||
    (typeof data.error === "string" && data.error.trim()) ||
    "";
  return m;
}

/** Toast server message when present; otherwise map HTTP status to a short hint. */
export function hrmsErrorToast(err, fallback = "Request failed.") {
  const data = err?.response?.data;
  const direct = messageFromResponseData(data);
  if (direct) {
    toast.error(direct);
    return;
  }
  const status = err?.response?.status;
  if (status === 400) {
    toast.error("Invalid request.");
    return;
  }
  if (status === 403) {
    toast.error("You do not have permission for this action.");
    return;
  }
  if (status === 404) {
    toast.error("Not found.");
    return;
  }
  if (status === 409) {
    toast.error("Conflict — the server rejected this action.");
    return;
  }
  if (status === 500) {
    toast.error("Server error. Please try again later.");
    return;
  }
  toast.error(getErpRequestErrorMessage(err, fallback));
}
